import { defFnOp } from "./compile/emit.js";
export const [sign, sign2, sign3, sign4] = defFnOp("Math.sign");
